import BaseHeadline from '../general/BaseHeadline'
import { THeading } from '../../types/index'
import BgHero from "../../assets/Bg-hero.png"
import { API } from '../../api/api'

type BaseSecondaryHeroType = {
    heading: THeading
    image?: string
}
export default function BaseSecondaryHero(props: BaseSecondaryHeroType) {
    return (
        <section className="w-full h-screen flex flex-col justify-center items-center relative overflow-hidden px-4">
            <div className="flex flex-col items-center justify-center z-30">

                <BaseHeadline
                    label={props.heading?.label}
                    tag="h1"
                    headline={props.heading?.headline}
                    text={props.heading?.text}
                    width="w-fit"
                    headlineClassProps="text-center max-w-4xl"
                    textClassProps='max-w-5xl'
                    center
                />
            </div>
            <div className="absolute top-0 left-0 w-full scale-125 h-[88vh] sm:h-screen flex flex-col justify-center items-center z-0 opacity-20 ">
                <img
                    src={props.image ? API.img + props.image : BgHero}
                    alt="Background Hero"
                />
            </div>
            <div className="absolute top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2 w-full h-screen flex flex-col justify-center items-center z-10 bg-gradient-to-r from-base-100 via-transparent to-base-100" />
        </section>
    )
}
